module.exports = __webpack_public_path__ + "img/1.95f606b7.jpg";